export const wppTypes = ['WPP-1', 'WPP-2', 'WPP-3', 'WPP-4', 'WPP-5', 'WPP-6'];
